import { useLocation } from 'react-router-dom'
import React from 'react'

/**
 * Hook for reporting page views to google analytics
 *
 * This needs to be ran within a component wrapped in
 * a Router from react-router since useLocation
 * relies on the context set but that.
 *
 * We also assume a ga object set on the window.
 */
export default function useReactRouterGaReporter() {
  const location = useLocation()
  React.useEffect(() => {
    if (window.ga) {
      window.ga('set', 'page', location.pathname)
      window.ga('send', 'pageview')
    }
  }, [location])
}
